export default __webpack_public_path__ + "static/media/phone_mockup.5ef02079.png";